import { TypeRichTextWithoutUnresolvableLinksResponse } from 'contentful-types'

import { mapSpacer } from 'src/siteBuilder/renderer/contentful/mapSpacer'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import { CONTENTFUL_TEXT_COLOUR_MAPPER, isVariantColor } from '@/siteBuilder/utils/text/mappers'
import RichText, { RichTextProps } from './RichText'

// TODO: add colors
const ContentfulRichText = withContentful<TypeRichTextWithoutUnresolvableLinksResponse['fields'], RichTextProps>(
  RichText,
  {
    spacer: mapSpacer,
    paragraphSize: (props): RichTextProps['paragraphSize'] =>
      props.fields.paragraphSize === 'medium' ? null : props.fields.paragraphSize,
    colour: ({ fields: { colour } }) => {
      if (isVariantColor(colour)) {
        return colour
      }
      return CONTENTFUL_TEXT_COLOUR_MAPPER[colour]
    },

    align: (props): RichTextProps['align'] =>
      props.fields.align?.toLowerCase() as Lowercase<TypeRichTextWithoutUnresolvableLinksResponse['fields']['align']>,
    linkColour: (props): RichTextProps['linkColour'] =>
      props.fields.linkColour?.toLowerCase() as Lowercase<
        TypeRichTextWithoutUnresolvableLinksResponse['fields']['linkColour']
      >,
    listIcon: (props): RichTextProps['listIcon'] => {
      const { iconName, iconColor2, iconSize } = props.fields
      return { iconName, iconColor: iconColor2, iconSize }
    },
  }
)

export default ContentfulRichText
